export default __webpack_public_path__ + "static/image7-556106a9d2ee9061c10144ea82d2f0ff.png";